import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Link, WebsiteIcon } from '@paypalcorp/pp-react';
import { MessageFormat } from '@paypalcorp/worldready';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';

import RenderSwitchComponent from '../../switchPanels/SwitchPanel';
import ExtraVariablesTextArea from '../../fields/ExtraVariablesTextArea';

const renderExtraVariablesAreaField = (props) => {
  return <ExtraVariablesTextArea {...props} />;
};

const AdvancedVariables = ({ extraVariablesView, noAdvancedVariables }) => {
  const worldReady = useContext(WorldReadyContext);

  const switchTitle = new MessageFormat(worldReady, {
    id: 'buttonsV3.advancedVariables.advanced.variables.switch.title',
  }).format();

  const switchSubtitle = new MessageFormat(worldReady, {
    id: 'buttonsV3.advancedVariables.advanced.variables.switch.subtitle',
  }).format();

  const placeholderLabel = new MessageFormat(worldReady, {
    id: 'buttonsV3.advancedVariables.advanced.variables.placeholder',
  }).format();

  const isChecked = noAdvancedVariables === 'no';

  return (
    <>
      <Field
        id="advanced-variables-switch"
        name="noAdvancedVariables"
        title={switchTitle}
        subTitle={switchSubtitle}
        component={RenderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
      />

      {isChecked && (
        <div className="advanced-variables">
          <Link
            className="dev-doc-link"
            href="https://developer.paypal.com/docs/paypal-payments-standard/integration-guide/Appx-websitestandard-htmlvariables"
            leftIcon={<WebsiteIcon size="sm" />}
            target="_blank"
            data-testid="dev-doc"
          >
            <Message id="buttonsV3.advancedVariables.advanced.variables.devDoc" />
          </Link>
          <Field
            id="extraVariablesView"
            name="extraVariablesView"
            type="text"
            label={placeholderLabel}
            value={extraVariablesView}
            component={renderExtraVariablesAreaField}
          />
        </div>
      )}
    </>
  );
};

AdvancedVariables.propTypes = {
  extraVariablesView: PropTypes.string,
  noAdvancedVariables: PropTypes.string,
};

export default AdvancedVariables;
